import * as React from "react";
import Svg, { Path } from "react-native-svg";
function HistoryBlue(props) {
    return (React.createElement(Svg, { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M3.666 12.333A8.333 8.333 0 1011.999 4a9.027 9.027 0 00-6.24 2.537L3.666 8.629", stroke: props.color || "#1434CB", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement(Path, { d: "M3.666 4v4.63h4.63M11.999 7.703v4.63l3.704 1.851", stroke: props.color || "#1434CB", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
}
export default HistoryBlue;
